class PlantCharacteristicsDescription {
  constructor(section) {
    this.section = section;
    this.description = section.closest('.product')?.querySelector('.product__description');

    if (!this.description) return;

    this.suppressDuplicate(
      'matureSize',
      /(?:^|[.;]\s*)(?:mature plant size|mature(?:s)? (?:size|height)|mature sixe|10 year size|size|height)\s*[:;]\s*(.*)$/i
    );
    this.suppressDuplicate('minimumTemperature', /(?:^|[.;]\s*)(?:minimum temperature|minimum temp)\s*:\s*(.*)$/i);
  }

  normalize(value) {
    return value
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/\s+([.,;:!?])/g, '$1')
      .trim()
      .toLocaleLowerCase();
  }

  suppressDuplicate(dataKey, pattern) {
    const displayedValue = this.section.dataset[dataKey];
    if (!displayedValue) return;
    if (dataKey === 'matureSize' && displayedValue === 'Coming soon...') return;

    const suppress = (node, text) => {
      const match = text.match(pattern);
      if (!match) return;

      const prefix = text.slice(0, match.index).replace(/[;\s]+$/, '').trim();
      if (prefix) {
        node.textContent = prefix;
      } else {
        node.remove();
      }
    };

    this.description.querySelectorAll('p, li, div').forEach((element) => {
      if (element.querySelector('p, li, div')) return;

      const text = element.textContent.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
      suppress(element, text);
    });

    [...this.description.childNodes].forEach((node) => {
      if (node.nodeType !== Node.TEXT_NODE) return;
      const text = node.textContent.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
      if (text) suppress(node, text);
    });
  }
}

const initializePlantCharacteristics = (root = document) => {
  root.querySelectorAll('.plant-characteristics').forEach((section) => {
    if (section.dataset.descriptionInitialized === 'true') return;
    section.dataset.descriptionInitialized = 'true';
    new PlantCharacteristicsDescription(section);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializePlantCharacteristics());
} else {
  initializePlantCharacteristics();
}

document.addEventListener('shopify:section:load', (event) => initializePlantCharacteristics(event.target));
